export const preloadCitiesList = [
  { id: 1, name: 'Київ', name_full_name_ua: 'м. Київ, Україна', zone: 1 },
  { id: 9, name: 'Дніпро', name_full_name_ua: 'м. Дніпро, Дніпропетровська  обл., Україна', zone: 2 },
  { id: 11, name: 'Львів', name_full_name_ua: 'м. Львів, Львівська  обл., Україна', zone: 1 },
  { id: 13, name: 'Одеса', name_full_name_ua: 'м. Одеса, Одеська  обл., Україна', zone: 2 },
  { id: 14, name: 'Харків', name_full_name_ua: 'м. Харків, Харківська  обл., Україна', zone: 2 },
  { id: 16, name: 'Запоріжжя', name_full_name_ua: 'м. Запоріжжя, Запорізька  обл., Україна', zone: 3 },
  { id: 17, name: 'Кривий Ріг', name_full_name_ua: 'м. Кривий Ріг, Дніпропетровська  обл., Україна', zone: 3 },
  { id: 21, name: 'Вінниця', name_full_name_ua: 'м. Вінниця, Вінницька  обл., Україна', zone: 4 },
  { id: 36, name: 'Маріуполь', name_full_name_ua: 'м. Маріуполь, Донецька  обл., Україна', zone: 4 },
  { id: 41, name: 'Полтава', name_full_name_ua: 'м. Полтава, Полтавська  обл., Україна', zone: 4 },
];
